jQuery($ => {
  class ProductsFeed {
    constructor(element) {
      this._        = element;
      this._element = $(element);
      this._main    = this._element.find('.o-products-feed__main');
      this._sidebar = this._element.find('.o-products-feed__sidebar');

      this._isLoading = false;

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._element.on('click', '.m-product-filters a', (e) => this.handleFilterClick(e));
      this._element.on('click', '.m-product-results .m-pagination a', (e) => this.handleFilterClick(e));
      this._element.on('submit', '.m-product-results .woocommerce-ordering', (e) => this.handleFormSubmit(e));

      $(window).on('popstate', (e) => this.handlePopState(e));
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Filter Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFilterClick(e) {
      const $link = $(e.currentTarget);
      const url = $link.attr('href');

      if (!url || url === '#') return;

      e.preventDefault();

      this.loadUrl(url, true);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Form Submit
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFormSubmit(e) {
      e.preventDefault();

      const $form  = $(e.currentTarget);
      const action = $form.attr('action') || window.location.pathname;
      const params = $form.serialize();
      const url    = action + (params ? '?' + params : '');

      this.loadUrl(url, true);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle PopState (browser back/forward)
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handlePopState(e) {
      this.loadUrl(window.location.href, false);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Load URL
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    loadUrl(url, pushState) {
      if (this._isLoading) return;

      this._isLoading = true;
      this._element.addClass('o-products-feed--loading');

      $.get(url)
        .done((html) => {
          const $response = $('<div>').html(html);

          const $newResults = $response.find('.m-product-results');
          const $newFilters = $response.find('.m-product-filters');

          if ($newResults.length) {
            this._main.find('.m-product-results').replaceWith($newResults);

            // Look for .m-product-results .woocommerce-ordering .orderby
            // When it changes, submit the form
            // WooCommerce does this by itself on the first load, but not after
            // the element is replaced in the DOM
            this._element.on('change', '.m-product-results .woocommerce-ordering .orderby', (e) => {
              $(e.currentTarget).closest('form').submit();
            });
          }

          if ($newFilters.length) {
            this._sidebar.find('.m-product-filters').replaceWith($newFilters);
          }

          if (pushState) {
            window.history.pushState(null, '', url);
          }

          this._element[0].scrollIntoView({ behavior: 'smooth', block: 'start' });

          this.setupHandlers();
        })
        .fail(() => {
          window.location.href = url;
        })
        .always(() => {
          this._isLoading = false;
          this._element.removeClass('o-products-feed--loading');
        });
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.products_feed = function() {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].products_feed = new ProductsFeed(_[i], opt);
      else
        ret = _[i].products_feed[opt].apply(_[i].products_feed, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-products-feed').products_feed();
});
